define('MultiAddToCart.Header.View', [
    'multi_add_to_cart_header.tpl',

    'Backbone',
    'underscore'
], function (
    multi_add_to_cart_header_tpl,

    Backbone,
    _
) {
    'use strict';

    return Backbone.View.extend({
        template: multi_add_to_cart_header_tpl,

        render: _(Backbone.View.prototype.render).wrap(function render(fn) {
            var _this = this;
            var args = arguments;
            var userProfile = _this.options.container.getComponent('UserProfile');

            userProfile.getUserProfile().done(function (profile) {
                _this.userProfile = profile;
            }).always(function () {
                fn.apply(_this, _(args).toArray().slice(1));
            });
        }),

        showHeader: function () {
            var _this = this;
            var plp = _this.options.container.getComponent('PLP');
            
            //uncomment if login is required
            // var configuration = _this.options.container.getComponent('Environment');
            // return _this.getRegistrationType !== 'disabled' && configuration.getSiteSetting('requireloginforpricing') === 'T' && _this.userProfile.isloggedin === true && plp.getDisplay().id === 'multi-add-to-cart';

            return plp.getDisplay().id === 'multi-add-to-cart';
        },

        getContext: function getContext() {
            return {
                isShowHeader: this.showHeader()
            };
        }
    });
});
